import { Button, Dialog, SystemIcon } from "@justworkshr/milo-components";
import EditUpsellDependent from "pages/CensusAndCurrentInformation/components/CurrentEmployees/EditUpsellDependent";
import { useState } from "react";
import { SingleDependentType } from "types";
import { useDeleteMdvDependentCensusMutation } from "types/generated/operations";
import {
  convertToTitleCase,
  ConvertToValidDate,
  errorMessageMap,
} from "utils/helper";
import { getProspectUuid } from "utils/idHelpers";
import styles from "./CurrentEmployees.module.css";
import Alert from "uicomponents/Alert";
import { trackFormError } from "utils/analytics/trackEvent";
interface IDeleteDependentProps {
  data: SingleDependentType;
  updateDependentList: (
    dependentInformation: any,
    method: "Delete" | "Add" | "Edit"
  ) => void;
}

const DeleteDependent = ({
  data,
  updateDependentList,
}: IDeleteDependentProps) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const closeDialog = () => setIsDeleteDialogOpen(false);
  const [editDependents, setEditDependents] = useState(false);

  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [deleteDependentCensuses, { loading: deleteDependentCensusesLoading }] =
    useDeleteMdvDependentCensusMutation();

  const handleDeleteDependent = async () => {
    try {
      await deleteDependentCensuses({
        variables: {
          prospectId: getProspectUuid(),
          uuids: [data.uuid],
        },
      });
      updateDependentList(data, "Delete");
      closeDialog();
      return;
    } catch (error: any) {
      const errorMessage: string = error?.message;
      errorMessageMap[errorMessage] &&
        setErrorMessage(errorMessageMap[errorMessage]);
      trackFormError(error, errorMessage);
      setIsError(true);
      return;
    }
  };

  return (
    <div className={styles.dependentboxDescription}>
      <div>
        <span
          className={styles.initials}
        >{`${data.firstName} ${data.lastName}`}</span>
        <div className={styles.depDetails}>
          {ConvertToValidDate(data.dateOfBirth || "")}
          <SystemIcon
            iconName="bullet"
            color="disabled"
            title="plus-circle"
            size="extra-small"
          />
          {convertToTitleCase(data.gender)}
          <SystemIcon
            iconName="bullet"
            color="disabled"
            title="plus-circle"
            size="extra-small"
          />
          {data.homeZip}
        </div>
      </div>
      <div>
        <SystemIcon
          iconName="edit"
          color="brand"
          title="Edit"
          size="small"
          className={styles.systemIcon}
          onClick={() => setEditDependents(true)}
        />
        <SystemIcon
          className={styles.systemIcon}
          iconName="trash"
          color="error"
          size="small"
          title="Trash"
          onClick={() => setIsDeleteDialogOpen(true)}
        />
      </div>
      {editDependents && (
        <EditUpsellDependent
          data={data}
          closeParentDialog={() => setEditDependents(false)}
          updateDependentList={updateDependentList}
        />
      )}
      <Dialog
        isOpen={isDeleteDialogOpen}
        onClose={closeDialog}
        title="Delete dependent?"
        primaryButton={
          <Button onClick={handleDeleteDependent} variant="filled">
            {deleteDependentCensusesLoading ? "Loading" : "Delete"}
          </Button>
        }
        secondaryButton={
          <Button onClick={closeDialog} variant="ghost">
            Back
          </Button>
        }
      >
        <p>
          Don’t forget, we need info for all dependents for each employee if
          those dependents are enrolled in your current plan or intend to enroll
          in a new plan.
        </p>
        <p>Are you sure you want to delete this dependent?</p>
        {isError && <Alert message={errorMessage} />}
      </Dialog>
    </div>
  );
};

export default DeleteDependent;
